import React from 'react'
import {graphql} from 'gatsby'
import Layout from './../components/layout'
import WorkSubNav from './../components/work-sub-nav'
import WorkSubHeading from './../components/work-sub-heading'
import GalleryGrid from './../components/gallery-grid'
// import {WATERCOLOURS_IMAGES} from './../constants/watercolours-images'
import WorkIntroText from './../components/work-intro-text'
import WorkFooterText from './../components/work-footer-text'
import ScrollToTop from './../components/scroll-to-top'

export default props => {
  const {data} = props
  const prismicData = {
    limitedEditionPrintsAreAvailable: data.prismicLimitedEditionPrintsPage.data.currently_available,
    introText: data.prismicWatercoloursPage.data.intro_text.html,
    footerText: data.prismicWatercoloursPage.data.footer_text.html,
    pageHeading: data.prismicWatercoloursPage.data.page_heading.text,
    images: data.prismicWatercoloursPage.data.images,
  }

  const WATERCOLOURS_IMAGES = prismicData.images.map(item => {
    return {
      title: item.image_title.text,
      fullUrl: item.image.url,
      thumbnailUrl: item.image.thumbnails.w400.url,
      orientation: item.image_orientation,
      supplementary_info: item.image_dimentions.text,
    }
  })

  return (
    <Layout pageName="watercolours" documentTitlePrefix={`${prismicData.pageHeading} | Work`}>
      <WorkSubNav
        currentPageName="watercolours"
        limitedEditionPrintsAreAvailable={prismicData.limitedEditionPrintsAreAvailable}
      />
      <WorkSubHeading headingText={prismicData.pageHeading} />
      <WorkIntroText html={prismicData.introText} />
      <GalleryGrid staticImagesFolderName="watercolours" imageData={WATERCOLOURS_IMAGES} classModifier="work" />
      <WorkFooterText html={prismicData.footerText} />
      <ScrollToTop />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    prismicLimitedEditionPrintsPage {
      data {
        currently_available
      }
    }
    prismicWatercoloursPage {
      data {
        page_heading {
          text
        }
        footer_text {
          html
        }
        intro_text {
          html
        }
        images {
          image_title {
            text
          }
          image_dimentions {
            text
          }
          image {
            url(imgixParams: {q: 70, h: 1400, fit: "scale"})
            thumbnails {
              w400 {
                url(imgixParams: {q: 50})
              }
            }
          }
          image_orientation
        }
      }
    }
  }
`
